import { render, staticRenderFns } from "./LocalWeatherDetails.html?vue&type=template&id=5b3ae02c&scoped=true&"
import script from "./LocalWeatherDetails.vue?vue&type=script&lang=js&"
export * from "./LocalWeatherDetails.vue?vue&type=script&lang=js&"
import style0 from "./LocalWeatherDetails.scss?vue&type=style&index=0&id=5b3ae02c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ae02c",
  null
  
)

export default component.exports